import { Dialog, DialogContent } from '@app/shared/ui/dialog';
import { FC } from 'react';
import { Button } from '@app/shared/ui/button';
import { useTranslation } from '@app/app/i18n';

export const WelcomeMessageModal: FC<{
  message: string;
  isOpen: boolean;
  onClose: () => void;
  buttonText?: string;
}> = ({ message, isOpen, onClose, buttonText }) => {
  const { t } = useTranslation('common');

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) return;
        onClose();
      }}
    >
      <DialogContent className="max-w-[49.625rem]" customCloseIcon={null}>
        <div className="flex flex-col gap-4 p-6">
          <h4 className="font-medium leading-none text-general_text_MII_default">
            {t('welcome.title')}
          </h4>
          <div className="welcome-message-content text-sm text-general_text_MII_secondary_i flex flex-col gap-3">
            <div dangerouslySetInnerHTML={{ __html: message }} />
            <Button variant="primary" size="text16" onClick={onClose} className="p-2">
              {buttonText || t('welcome.ok')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
